module.exports = __webpack_public_path__ + "img/sanae kochiya_lw.2b5b028a.png";